import { yupResolver } from '@hookform/resolvers/yup'
import PropTypes from 'prop-types'
import { FormProvider, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import SidePopover from '@/components/side-popover/SidePopover.jsx'
import FinalBalanceForm from '@/pages/projects/list/projects-form/final-balance-form/FinalBalanceForm.jsx'
import {
    DEFAULT_FINAL_BALANCE_MOCK,
    validationSchema,
} from '@/pages/projects/list/projects-form/final-balance-form/finalBalance.schema.js'

const FinalBalanceWrapper = ({
    dataForm,
    openDialogDelete,
    closeModal,
    customers,
    successManagers,
    teams,
    canNotDelete,
}) => {
    const { t } = useTranslation()

    const methods = useForm({
        shouldUnregister: false,
        mode: 'all',
        reValidateMode: 'onChange',
        nativeValidation: false,
        shouldFocusError: true,
        resolver: yupResolver(validationSchema),
        defaultValues: DEFAULT_FINAL_BALANCE_MOCK,
    })

    const {
        formState: { isDirty },
    } = methods

    return (
        <FormProvider {...methods}>
            <SidePopover
                onClose={() => closeModal(isDirty)}
                isDirty={isDirty}
                title={
                    dataForm?.isEdit
                        ? t(`final_balance.edit_title`)
                        : t(`final_balance.create_title`)
                }
            >
                <FinalBalanceForm
                    dataForm={dataForm}
                    isEdit={dataForm?.isEdit}
                    openDialogDelete={openDialogDelete}
                    successManagers={successManagers}
                    closeModal={closeModal}
                    customers={customers}
                    teams={teams}
                    canNotDelete={canNotDelete}
                />
            </SidePopover>
        </FormProvider>
    )
}

export default FinalBalanceWrapper

FinalBalanceWrapper.propTypes = {
    onClose: PropTypes.func,
    dataForm: PropTypes.object,
    openDialogDelete: PropTypes.func,
    closeModal: PropTypes.func,
    customers: PropTypes.array,
    teams: PropTypes.array,
    successManagers: PropTypes.array,
    canNotDelete: PropTypes.bool,
}
